module.exports = __webpack_public_path__ + "static/media/1.9bca9bd8.jpeg";